import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subCategoryList: [],
};

const subCategoryListSlice = createSlice({
  name: "subcategorylist",
  initialState: initialState,
  reducers: {
    setSubCategoryList(state, action) {
      state.subCategoryList = action.payload;
    },
    appendSubCategoryList: (state, action) => {
      state.subCategoryList = [...state.subCategoryList, ...action.payload];
    },
    clearSubCategoryList: (state) => {
      state.subCategoryList = [];
    },
  },
});

export const {
  setSubCategoryList,
  appendSubCategoryList,
  clearSubCategoryList,
} = subCategoryListSlice.actions;
export default subCategoryListSlice.reducer;
